import React from "react"
import useStyles from "../../hooks/useStyles"
const Footer = ({ variant }) => {
    const year = new Date().getFullYear()
    const classes = useStyles()
    const footerTheme = variant.toLowerCase() === "light" ? classes.footerLight : classes.footerDark
    return (
        <footer className={footerTheme}>
            Copyright Flexia Payments LLC &copy; {year} All Rights Reserved
        </footer>
    )
}
Footer.defaultProps = {
    variant: 'dark'
}
export default Footer